import { useState, useEffect, useContext } from "react";
import InputHeader from "../input/InputHeader";
import ReactSelect, { createFilter } from "react-select";
import styles from "./Dropdowns.module.css";
import { customStyle, customStyleLight } from "./CustomStyle";
import SectionHeader from "../labels/SectionHeader";
import features from "../../../pages/collect/features";
import InputCard from "../containers/InputCard";
import ThemeContext, { themes } from "../../context/ThemeContext";

const FeatureTypeSelect = ({
  sdeTable,
  identifier,
  value,
  selectHandler,
  required,
}) => {
  const themeCtx = useContext(ThemeContext);
  const [options, setOptions] = useState(null);
  const [status, setStatus] = useState("");

  useEffect(() => {
    let selectOptions = getOptions(sdeTable);
    selectOptions.length === 0
      ? setStatus(
          `Error, failed to build feature type dropdown list for type: ${sdeTable}`
        )
      : setOptions(selectOptions);
  }, [sdeTable]);

  const getOptions = (sdeTable) => {
    let options;
    switch (sdeTable) {
      case "POLE":
        options = features
          .filter((feature) => feature.sde_table === "POLE")
          .map((feature) => {
            return {
              value: feature.feature,
              label: feature.label,
            };
          });
        break;
      case "STRUCTURE":
        options = features
          .filter((feature) => feature.sde_table === "STRUCTURE")
          .map((feature) => {
            return {
              value: feature.feature,
              label: feature.label,
            };
          });
        break;
      case "SPLICECLOSURE":
        options = features
          .filter((feature) => feature.sde_table === "SPLICECLOSURE")
          .map((feature) => {
            return {
              value: feature.feature,
              label: feature.label,
            };
          });
        break;
      default:
        options = features.map((feature) => {
          return {
            value: feature.feature,
            label: feature.label,
          };
        });
        break;
    }
    return options;
  };

  let dropdownStyle =
    themeCtx.currentTheme() === themes.light ? customStyleLight : customStyle;

  return (
    <InputCard>
      {!status && options?.length > 0 && (
        <>
          <InputHeader text="Type" required={required} />
          <ReactSelect
            className={styles.dropdown}
            value={value}
            onChange={selectHandler}
            options={options}
            filterOption={createFilter({ ignoreAccents: false })}
            styles={dropdownStyle}
            name={identifier}
            id={identifier}
            isSearchable={false}
          />
        </>
      )}
      {status && <SectionHeader text={status} />}
    </InputCard>
  );
};

export default FeatureTypeSelect;
